import React, { Component } from 'react';
import { connect } from 'react-redux';
import { logoutRequest } from '../../redux/actions/account_actions/login.actions';
import { trim } from '../../../../shared/helpers';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';

const mapStateToProps = (state) => {
    const { categories, loading } = state.App.App_content;
    return { categories, loading };
};

class SidebarContent extends Component {
    hideSidebar = () => this.props.onClick();

    userLogout = () => this.props.dispatch(logoutRequest(null));

    render() {
        const { categories, loading } = this.props;

        return !loading
            && (
                <div className="sidebar__content">
                    {
                        categories.map(category => (
                            category.views.length
                                ? (category.position === 1 || category.position === 8)
                                    ? (
                                        <ul className="sidebar__block" key={category.URL}>
                                            <SidebarLink
                                                title={category.displayName}
                                                icon={category.icon}
                                                route={category.position !== 8 ? `/${category.displayName}` : `/${category.name}/${trim(category.displayName)}`}
                                                onClick={this.hideSidebar}
                                            />
                                        </ul>
                                    )
                                    : (
                                        <ul className="sidebar__block" key={category.URL}>
                                            <SidebarCategory title={category.displayName} icon={category.icon}>
                                                {
                                                    category.views.map((view, index) => (
                                                        view.inSidebar
                                                            ? (
                                                                <SidebarLink
                                                                    key={index}
                                                                    external_link={view.external_link}
                                                                    title={view.displayName}
                                                                    route={`/${category.name}/${view.name}`}
                                                                    onClick={this.hideSidebar}
                                                                />
                                                            )
                                                            : null
                                                    ))
                                                }
                                            </SidebarCategory>
                                        </ul>
                                    ) : null
                        ))
                    }
                    <ul className="sidebar__block">
                        <SidebarLink
                            title="Logout"
                            icon="exit"
                            route="/login"
                            onClick={this.userLogout}
                        />
                    </ul>
                </div>
            );
    }
}

export default connect(mapStateToProps, null)(SidebarContent);



// WEBPACK FOOTER //
// ./src/modules/App/components/sidebar/SidebarContent.js